import {
  resolveFeedbackCaptureGate,
  type FeedbackCaptureGate,
} from "@mcblessing1/in-app-feedback";
import { isPostHogClientConfigured } from "@/lib/analytics/posthog-env";
import {
  hasProductFeedbackSurveyId,
  isProductFeedbackMasterEnabled,
} from "./productFeedbackEnv";

/**
 * Package defaults to blocking `/admin`. SIO D6: admin routes stay allowed
 * (feature requests). Use an unreachable prefix so the package check never fires.
 */
export const PRODUCT_FEEDBACK_ADMIN_PATH_PREFIX_DISABLED =
  "/__product_feedback_no_admin_block__";

export type ResolveProductFeedbackGateOptions = {
  pathname?: string;
  /**
   * Override master enable (env ∧ Admin Settings). Prefer omitting —
   * defaults to `isProductFeedbackMasterEnabled()`.
   */
  enabled?: boolean;
};

/**
 * Host gate for product feedback (D6/D7/D12): no end-user opt-out; admin paths allowed.
 */
export function resolveProductFeedbackGate(
  options: ResolveProductFeedbackGateOptions = {},
): FeedbackCaptureGate {
  const pathname =
    options.pathname ??
    (typeof window !== "undefined" ? window.location.pathname : "/");

  const enabled = options.enabled ?? isProductFeedbackMasterEnabled();

  return resolveFeedbackCaptureGate({
    enabled,
    hasPostHogKey: isPostHogClientConfigured(),
    hasSurveyId: hasProductFeedbackSurveyId(),
    pathname,
    optedOut: false,
    adminPathPrefix: PRODUCT_FEEDBACK_ADMIN_PATH_PREFIX_DISABLED,
  });
}
